"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeDescriptor = void 0;
const type_check_1 = require("@pallad/type-check");
const isErrorWithCodeFactory_1 = require("./isErrorWithCodeFactory");
const CHECK = new type_check_1.TypeCheck('@pallad/errors/CodeDescriptor');
class CodeDescriptor {
    constructor(code) {
        this.code = code;
        CHECK.assign(this);
        this.is = (0, isErrorWithCodeFactory_1.isErrorWithCodeFactory)(code);
    }
    static isType(value) {
        return CHECK.isType(value);
    }
}
exports.CodeDescriptor = CodeDescriptor;
